import type { TodayButton as DxTodayButton } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import RoundedButton from '@components/RoundedButton/RoundedButton';

import { TodayButtonWrapper } from './TodayButton.style';

const messages = defineMessages({
  today: {
    id: 'todayButton.today',
    defaultMessage: 'Today',
  },
});

/**
 * VITALL-styled today button component for the routine scheduler toolbar
 */
const TodayButton = ({ ...props }: DxTodayButton.ButtonProps) => {
  const { formatMessage } = useIntl();
  const { setCurrentDate } = props;

  return (
    <TodayButtonWrapper>
      <RoundedButton
        autoSize
        height={32}
        onClick={() => setCurrentDate(new Date())}
        variant="white"
      >
        {formatMessage(messages.today)}
      </RoundedButton>
    </TodayButtonWrapper>
  );
};

export default TodayButton;
